import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDIcon, FDPaper, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

export const PM2JourneyInvestingTidbitLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDPaper width={350} appearance="flat">
      <FDStack direction="column" spacing={1} padding={3} alignItems="center">
        {resource.attr('icon') ? <FDIcon icon={resource.attr('icon')} size="md" /> : null }
        <MetaControlField attr="name" />
        <MetaControlField attr="description" />
      </FDStack>
    </FDPaper>
  );
};
